import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = [
  { name: 'list', component: () => import('@/view/list.vue'), meta: { title: '' } },
  { name: 'list/detail', component: () => import('@/view/article/detail.vue'), meta: { title: '' } },
  { name: 'exam-sign/index', component: () => import('@/view/examSign/index.vue'), meta: { title: '考级报名' } },
  { name: 'exam-sign/user-edit', component: () => import('@/view/examSign/user-edit.vue'), meta: { title: '报名信息' } },
  { name: 'exam-sign/exam-question-edit', component: () => import('@/view/examSign/exam-question-edit.vue'), meta: { title: '报考选择' } },
  { name: 'exam-sign/detail', component: () => import('@/view/examSign/detail.vue'), meta: { title: '报考详情' } },
  // { name: 'exam-sign/category', component: () => import('@/view/examSign/category.vue'), meta: { title: '全部专业' } },
  // { name: 'exam-sign/signup', component: () => import('@/view/examSign/signup.vue'), meta: { title: '专业报名' } },
  // { name: 'exam-sign/select', component: () => import('@/view/examSign/select.vue'), meta: { title: '报考选择' } },
  // { name: 'exam-sign/info', component: () => import('@/view/examSign/info.vue'), meta: { title: '报考信息' } },
  { name: 'exam-sign/exam-result-list', component: () => import('@/view/examSign/exam-result-list.vue'), meta: { title: '成绩查询' } },
  { name: 'exam-sign/exam-result', component: () => import('@/view/examSign/exam-result.vue'), meta: { title: '查看考试结果' } },
  { name: 'exam-sign/certificate-list', component: () => import('@/view/examSign/certificate-list.vue'), meta: { title: '证书管理' } },
  { name: 'exam-sign/certificate', component: () => import('@/view/examSign/certificate.vue'), meta: { title: '查看证书' } },
  { name: 'exam-sign/organization-introduce', component: () => import('@/view/examSign/organization-introduce.vue'), meta: { title: '考级介绍' } },
  { name: 'exam-sign/sign-up-explain', component: () => import('@/view/examSign/sign-up-explain.vue'), meta: { title: '考级报名' } },
  { name: 'exam-sign/video-capture-explain', component: () => import('@/view/examSign/video-capture-explain.vue'), meta: { title: '视频拍摄' } },
  { name: 'exam-sign/video-upload-explain', component: () => import('@/view/examSign/video-upload-explain.vue'), meta: { title: '视频上传' } },
  { name: 'express/express-list', component: () => import('@/view/express/express-list.vue'), meta: { title: '作品邮寄' } },
  { name: 'express/express-edit', component: () => import('@/view/express/express-edit.vue'), meta: { title: '填写寄件信息' } },
  { name: 'express/express-explain', component: () => import('@/view/express/express-explain.vue'), meta: { title: '作品邮寄' } },
  { name: 'refund/refund-list', component: () => import('@/view/refund/refund-list.vue'), meta: { title: '退款订单' } },
  { name: 'refund/refund-edit', component: () => import('@/view/refund/refund-edit.vue'), meta: { title: '申请退款' } },
  { name: 'refund/refund-detail', component: () => import('@/view/refund/refund-detail.vue'), meta: { title: '退款详情' } },
  { name: 'login', component: () => import('@/view/index/login.vue'), meta: { title: '' } },
  { name: 'test', component: () => import('@/view/index/test.vue'), meta: { title: '测试页面' } },
  { path: '*', redirect: '/list' }
]
routes.forEach((route) => {
  route.path = route.path || '/' + (route.name || '')
})
const router = new Router({ routes })
router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})
export { router }
